import { render, staticRenderFns } from "./PortalNotificationPanel.vue?vue&type=template&id=39579c88&scoped=true&"
import script from "./PortalNotificationPanel.vue?vue&type=script&lang=ts&"
export * from "./PortalNotificationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PortalNotificationPanel.vue?vue&type=style&index=0&id=39579c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39579c88",
  null
  
)

export default component.exports